import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeUnderscoreDash'
})
export class RemoveUnderscoreAndDashPipe implements PipeTransform {
  transform(value: any, removePipe: string, args?: any): any {
    if (!value) {
      return value;
    }
    return value.split(removePipe).join(' ');
  }
}
